import React, {useState, useEffect} from 'react';
import Breadcrumbs from '../Breadcrumbs';
import { Rating } from '@smastrom/react-rating';
import PopupCasino from './PopupCasino';
import Modal from 'react-bootstrap/Modal';

const HeroCasino= ({title, featuredImage, bonus, rtp, zUser, externalLink, idx, rating, ratingStyles, logoBg, follow, popupCasino, pt, pl, plp}) => {

  const [modalShow, setModalShow] = useState(false);

  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);

  useEffect(() => {
    window.dataLayer.push({
      event: 'pageview',
      pageTitle: title,
      pagePath: window.location.href,
    });
  }, []);

  return (
    <div id={idx} className="casino-herocontainer-fluid bg-white mb-0 d-flex flex-column position-relative pt-0 pb-3 pb-lg-5">
      <div className="container">
        <Breadcrumbs active={title} levels={2} />
        <div className="d-flex flex-column flex-lg-row align-items-lg-stretch flex-grow-1 position-relative z-1 mt-5">
          <div className="col-12 col-lg-5 d-flex flex-column p-4 align-items-center justify-content-center"
          style={logoBg ? {background: '#' + logoBg} : {background: '#F9F9F9'}}>
            <img src={featuredImage} alt={title} className="flex-grow-0 w-auto"></img>
          </div>
          <div className="col-12 col-lg-7 d-flex flex-column justify-content-start ps-lg-4">
            <h1 className="fw-bold mb-4">{title}</h1>
            <div className="col-12 d-flex flex-column flex-lg-row align-items-center">
              <div className="fs-2 fw-bold me-lg-4">{rating ? rating + ' / 5' : ''}</div>
              <div className="d-flex flex-column align-items-center">
                <Rating
                  style={{ maxWidth: 86 }}
                  value={rating}
                  itemStyles={ratingStyles}
                  readOnly
                />
              </div>
              {zUser ?
              <div className="d-flex align-items-center ms-4"><span className="text-primary fs-2 fw-bold me-2">{zUser}%</span> Zufriedene User</div>
              : null }
          </div>
          { pt ? 
            <>
              <Modal show={modalShow} onHide={handleClose}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              >
                <Modal.Header closeButton className="bg-secondary border-0">
                  <Modal.Title id="contained-modal-title-vcenter">
                    {pt}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                  <PopupCasino pl={pl} plp={plp} popupCasino={popupCasino} externalLink={externalLink}></PopupCasino>
                </Modal.Body>
              </Modal>
              <button className="my-4 btn btn-secondary rounded-0 align-self-start" type="button" onClick={handleShow}>Jetzt Spielen</button>
            </>
          :
            <div className="my-4">
              { externalLink ?
              <a href={externalLink} className="btn btn-secondary rounded-0" target="_blank" rel={follow ? '' : 'nofollow'} >Jetzt Spielen</a>
              : null }
            </div>
          }
          <div className="d-flex">
            { bonus ?
            <div className="d-flex flex-column p-2 bg-light">
              <span>Bonus bis zu</span>
              <span className="fw-bold">{bonus ? bonus + '€' : 'unbekannt'}</span>
            </div>
            : null }
            { rtp ?
            <div className="d-flex flex-column p-2 bg-light ms-3">
              <span>RTP</span>
              <span className="fw-bold">{rtp ? rtp + '%' : 'unbekannt'}</span>
            </div>
            : null }
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroCasino;